import React, { Suspense, lazy, useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { SnackbarProvider } from "notistack";

//Global StyleSheet for Slider 
import "swiper/css";
import "swiper/css/pagination";
import BarLoader from "react-spinners/BarLoader";
import colors from "./assets/theme/base/colors";
import { Stack } from "@mui/material";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import {store} from "./redux/store";
import { useNavigate } from "react-router-dom";


// Layouts
import Layout from "./components/Layout/Layout";
import Logout from "./components/Logout/Logout";

//RoadMap
const RoadMapSecurity = lazy(() => import("./pages/Roadmap/Roadmap"))
// Assets
import "./assets/styles/defaults.css";
import "./assets/fonts/css/style.css";
import { customTheme, RTL } from "./assets/theme";
import { ThemeProvider } from "@mui/material/styles";
import { Courses } from "./pages/Couerses/Courses";
import useHttp from "hooks/use-http";

const Home = lazy(() => import("./pages/Home/Home"));
const Login = lazy(() => import("./pages/Login/Login"));
const Register = lazy(() => import("./pages/Register/Register"))
const TopCourses = lazy(() => import("./pages/TopCourses/TopCourses"))
const TopQuizes = lazy(() => import("./pages/TopQuizes/TopQuizes"))
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"))
const CourseDetail = lazy(() => import("./pages/CourseDetail/CourseDetail"))
const UserCourse = lazy(() => import("./pages/UserCourse/UserCourse"))
const UserQuiz = lazy(() => import("./pages/UserQuiz/UserQuiz"))
const PreviewQuiz = lazy(() => import('./pages/PreviewQuiz/PreviewQuiz'));
const AboutUsNew = lazy(() => import('./pages/AboutUs/AboutUs'));
const Provision = lazy(() => import('./pages/Provision/Provision'));
const ProtectRoute = lazy(() => import('./pages/ProtectRoute/ProtectRoute'));

function App() {

    const [historyLocation, setHistoryLocation] = useState({});
    const location = useLocation();
    const infoState = useSelector((state) => state);
    const [timeSpentOnPage, setTimeSpentOnPage] = useState(0);
    const [totalTimeSpent, setTotalTimeSpent] = useState(0);
    const { sendRequest: updateTotalActivityTime } = useHttp();
    const navigate = useNavigate();

    const authHandler = ()=>{
        navigate("/auth/login")
    }


    return (
        <RTL>
            <Provider store={store} >
                <ThemeProvider theme={customTheme}>
                    <SnackbarProvider>
                        <Suspense
                            fallback={
                                <Stack justifyContent="center" alignItems="center" minHeight="100vh">
                                    <BarLoader color={colors.info.main} />
                                </Stack>
                            }>
                            <Routes>
                                <Route path="/" element={<Layout />}>
                                    <Route index element={<Home check_auth={infoState.auth?.check_auth} infoUser={infoState.auth?.user}/>} />
                                    <Route path="about_us" element={<AboutUsNew check_auth={infoState.auth?.check_auth} />} />
                                    <Route path="provision" element={<Provision check_auth={infoState.auth?.check_auth} />} />
                                    <Route path="courses/:categoryId" element={<Courses check_auth={infoState.auth?.check_auth} />} />
                                    <Route path="topcourses" element={<TopCourses check_auth={infoState.auth?.check_auth}/>} />
                                    <Route path="topquizes" element={<TopQuizes check_auth={infoState.auth?.check_auth} />} />
                                    <Route path="course/:id" element={<UserCourse />} />
                                    <Route path="quiz/:id" element={<UserQuiz />} />
                                    <Route path="coursedetail/:educationId" element={<CourseDetail check_auth={infoState.auth?.check_auth} infoUser={infoState.auth.user} />} />
                                    <Route path="courses/coursedetail/:educationId" element={<CourseDetail check_auth={infoState.auth?.check_auth} infoUser={infoState.auth.user} />} />
                                    <Route path="quizes/quizdetail/:quizId" element={<UserQuiz />} />
                                    <Route path="quizdetail/:quizId" element={<UserQuiz />} />
                                    <Route path="quizdetail/:quizId/preview-quiz" element={<PreviewQuiz />} />
                                    <Route path="auth/register" element={<Register check_auth={infoState.auth?.check_auth} state={{ historyLocation }} />} />
                                    <Route path="auth/login" element={<Login />} />
                                    <Route path="logout" element={<Logout />} />
                                    <Route path="road_map" element={<RoadMapSecurity check_auth={infoState.auth?.check_auth} />} />
                                    <Route path="dashboard/*" element={<ProtectRoute authHandler={authHandler}> <Dashboard check_auth={infoState.auth?.check_auth} /> </ProtectRoute>} />
                                </Route>
                            </Routes>
                        </Suspense>
                    </SnackbarProvider>
                </ThemeProvider>
            </Provider>  
        </RTL>
    );
}

export default App;
